<template>
  <div>
    <div v-if="show_card">
      <div class="datosTabla">
        <table class="table able-bordered table-hover table-condensed card">
          <tbody>
            <tr>
                <td class="center"><strong>Hoyo</strong></td>
                <td class="center"><strong>1</strong></td>
                <td class="center"><strong>2</strong></td>
                <td class="center"><strong>3</strong></td>
                <td class="center"><strong>4</strong></td>
                <td class="center"><strong>5</strong></td>
                <td class="center"><strong>6</strong></td>
                <td class="center"><strong>7</strong></td>
                <td class="center"><strong>8</strong></td>
                <td class="center"><strong>9</strong></td>
                <td class="center"><strong>1ªVta</strong></td>
                <td class="center"><strong>10</strong></td>
                <td class="center"><strong>11</strong></td>
                <td class="center"><strong>12</strong></td>
                <td class="center"><strong>13</strong></td>
                <td class="center"><strong>14</strong></td>
                <td class="center"><strong>15</strong></td>
                <td class="center"><strong>16</strong></td>
                <td class="center"><strong>17</strong></td>
                <td class="center"><strong>18</strong></td>
                <td class="center"><strong>2ªVta</strong></td>
                <td class="center"><strong>Total</strong></td>
            </tr>
            <tr>
              <td>Par</td>
              <td v-for="course_hole in course.holes" v-if="course_hole.number < 10" class="center">
                <input readonly="" tabindex="-1" value="{{ course_hole.par }}" class="card-hole">
              </td>
              <td></td>
              <td v-for="course_hole in course.holes" v-if="course_hole.number > 9" class="center">
                <input readonly="" tabindex="-1" value="{{ course_hole.par }}" class="card-hole">
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Vtja</td>
              <td v-for="course_hole in course.holes" v-if="course_hole.number < 10" class="center">
                <input readonly="" tabindex="-1" value="{{ course_hole.handicap }}" class="card-hole">
              </td>
              <td></td>
              <td v-for="course_hole in course.holes" v-if="course_hole.number > 9" class="center">
                <input readonly="" tabindex="-1" value="{{ course_hole.handicap }}" class="card-hole">
              </td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Ronda</td>
              <td v-for="hole in holes_out" class="center">
                <input v-model="hole.value" class="card-hole" v-bind:class="evalPar(hole)" v-focus="$index === focused">
              </td>
              <td class="center">{{ out }}</td>
              <td v-for="hole in holes_in" class="center">
                <input v-model="hole.value" class="card-hole" v-bind:class="evalPar(hole)">
              </td>
              <td class="center">{{ in }}</td>
              <td class="center">{{ par }}</td>
            </tr>
            <tr>
              <td>Dif.</td>
              <td v-for="hole in holes_out" class="center">
                <input readonly tabindex="-1" class="card-hole" value="{{ evalDiff(hole) }}">
              </td>
              <td class="center"></td>
              <td v-for="hole in holes_in" class="center">
                <input readonly tabindex="-1" class="card-hole" value="{{ evalDiff(hole) }} ">
              </td>
              <td class="center"></td>
              <td class="center">{{ diff }}</td>
            </tr>
            <tr>
              <td>Gross</td>
              <td v-for="hole in holes_out" class="center">
                <input readonly tabindex="-1" class="card-hole" value="{{ evalPoints(hole) }}">
              </td>
              <td class="center">{{ pointsOut }}</td>
              <td v-for="hole in holes_in" class="center">
                <input readonly tabindex="-1" class="card-hole" value="{{ evalPoints(hole) }} ">
              </td>
              <td class="center">{{ pointsIn }}</td>
              <td class="center">{{ cardPoints }}</td>
            </tr>
            <tr>
              <td>Neto</td>
              <td v-for="hole in holes_out" class="center">
                <input readonly tabindex="-1" class="card-hole" value="{{ evalNetPoints(hole) }}">
              </td>
              <td class="center">{{ pointsNetOut }}</td>
              <td v-for="hole in holes_in" class="center">
                <input readonly tabindex="-1" class="card-hole" value="{{ evalNetPoints(hole) }} ">
              </td>
              <td class="center">{{ pointsNetIn }}</td>
              <td class="center">{{ cardNetPoints }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <button class="btn btn-success save-card" @click="saveCard">Guardar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .card-hole {
    width:25px;
  	height:auto;
  	font-size:12px;
  }

  .save-card {
    float:right;
  	margin-top:15px;
  }

  .card {
    width:100%;
  	height:auto;
  	float:left;
  	overflow:hidden;
  	overflow-x:auto;
  }

  .par {
    background-color: rgba(151, 151, 151, 0.4);
  }

  .birdie {
    background-color: rgba(173, 19, 9, 0.4);
  }

  .bogey {
    background-color: rgba(11, 102, 200, 0.4);
  }

  .eagle {
    background-color: rgba(250, 216, 22, 0.4);
  }

  .double-bogey {
    background-color: rgba(0, 0, 0, 0.4);
    color: white;
  }
</style>
<script>
  import configure from '../configure'
  import {
    getCurrentChampionship,
    getCurrentDate,
    getCurrentCourse,
    getCurrentCard,
    getCurrentPlayer,
    getHolesIn,
    getHolesOut,
    getLoading,
    getShowCard,
    getShowPlayerCards
  } from '../vuex/getters'
  import * as actions from '../vuex/actions'
  import {focus} from 'vue-focus'

  export default {
    directives: {focus},
    vuex: {
      getters: {
        championship: getCurrentChampionship,
        date: getCurrentDate,
        course: getCurrentCourse,
        card: getCurrentCard,
        player: getCurrentPlayer,
        holes_in: getHolesIn,
        holes_out: getHolesOut,
        show_spinner: getLoading,
        show_card: getShowCard,
        edit_card: getShowPlayerCards
      },
      actions: actions
    },
    created() {
      this.resetHoles()
    },
    ready() {
      this.initHoles()
    },
    computed: {
      par() {
        return this.out + this.in
      },
      out() {
        let total = 0
        let card = this.card
        this.holes_out.forEach((h) => {
          let p = h.id
          if (h.value) {
            total += parseInt(h.value)
            card[p] = parseInt(h.value)
          }
        })
        this.setCard(card)
        return total
      },
      in() {
        let total = 0
        let card = this.card
        this.holes_in.forEach((h) => {
          let p = h.id
          if (h.value) {
            total += parseInt(h.value)
            card[p] = parseInt(h.value)
          }
        })
        this.setCard(card)
        return total
      },
      diff() {
        if (this.par == 0) {
          return 0
        }
        let diff = this.par - this.course.par
        if (diff > 0) {
          return '+' + diff
        }
        return diff
      },
      focused() {
        if (this.show_card == true) {
          return 0
        }
        return null
      },
      cardPoints() {
        return this.pointsIn + this.pointsOut
      },
      cardNetPoints() {
        return this.pointsNetIn + this.pointsNetOut
      },
      pointsIn() {
        let total = 0
        this.holes_in.forEach((h) => {
          let points = this.evalPoints(h)
          if (points == '') {
            points = 0
          }
          total += parseInt(points)
        })
        return total
      },
      pointsOut() {
        let total = 0
        this.holes_out.forEach((h) => {
          let points = this.evalPoints(h)
          if (points == '') {
            points = 0
          }
          total += parseInt(points)
        })
        return total
      },
      pointsNetIn() {
        let total = 0
        this.holes_in.forEach((h) => {
          let points = this.evalNetPoints(h)
          if (points == '') {
            points = 0
          }
          total += parseInt(points)
        })
        return total
      },
      pointsNetOut() {
        let total = 0
        this.holes_out.forEach((h) => {
          let points = this.evalNetPoints(h)
          if (points == '') {
            points = 0
          }
          total += parseInt(points)
        })
        return total
      }
    },
    methods: {
      saveCard() {
        if (this.edit_card === true) {
          this.updateCard()
          return false
        }
        this.setLoading(true)
        this.card.registration_id = this.player.id
        this.card.date_id = this.date.id
        this.$http.post(
          configure.api_url + 'cards',
          this.card
        ).then((response) => {
          this.addPlayerToReady(this.player)
          this.setCardSaved(true)
          this.resetCard()
          this.setLoading(false)
          this.showPlayer(false)
          this.showCard(false)
          this.initHoles()
        }, (error) => {
          this.setLoading(false)
          alert('Error saving card')
        })
      },
      updateCard() {
        this.setLoading(true)
        this.$http.put(
          configure.api_url + 'cards/' + this.card.id,
          this.card
        ).then((response) => {
          this.setCard(response.data)
          this.setLoading(false)
          this.showCard(false)
          this.initHoles()
        }, (error) => {
          this.setLoading(false)
          alert('Error updating card')
        })
      },
      evalPar(hole) {
        let diff = parseInt(hole.value) - parseInt(hole.par)
        let style = {}
        if (diff < -1) {
          style = {'eagle': true}
        }
        if (diff == -1) {
          style = {'birdie': true}
        }
        if (diff == 0) {
          style = {'par': true}
        }
        if (diff == 1) {
          style = {'bogey': true}
        }
        if (diff > 1) {
          style = {'double-bogey': true}
        }

        if (parseInt(hole.value) == 0) {
          style = {}
        }
        return style
      },
      evalDiff(hole) {
        if (hole.value > 0) {
          let diff = parseInt(hole.value) - parseInt(hole.par)
          if (diff > 0) {
            return '+' + diff
          }
          return diff
        }
        return ''
      },
      evalPoints(hole) {
        let diff = this.evalDiff(hole)
        let points = ''
        if (hole.value > 0) {
          points = Math.abs(diff - 2)
          if (diff >= 2) {
            points = 0
          }
          if (diff <= -3) {
            points = 5
          }
        }
        return points
      },
      evalNetPoints(hole) {
        let handicap = this.player.handicap
        let cardHandicap = 0
        if (handicap > 18) {
          cardHandicap = Math.floor(handicap / 18)
          handicap = handicap - 18 * cardHandicap
        }
        console.log(cardHandicap)
        let diff = this.evalDiff(hole) - cardHandicap
        if (hole.handicap <= handicap) {
          diff = diff -1
        }
        let points = ''
        if (hole.value > 0) {
          points = Math.abs(diff - 2)
          if (diff >= 2) {
            points = 0
          }
          if (diff <= -3) {
            points = 5
          }
        }
        return points
      }
    }
  }
</script>



/** WEBPACK FOOTER **
 ** Card.vue?35c438e8
 **/